<template>
  <div class="pages">
    <div v-if="empty === false" class="card-container">
      <div class="card-header">
        <div class="q-icon">问</div>
        <div class="card-header_title">{{ this.problem }}</div>
      </div>
      <div class="card-body">
        <div class="a-icon">答</div>
        <div class="editor">
          <Editor v-model="html" :defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated" />
        </div>
      </div>
    </div>
    <div v-if="empty === true" class="tips-box">
      <img src="../../assets/img/20241017-161801.png" alt="" />
      <div class="tips-box-text">未找到数据~</div>
    </div>
  </div>
</template>
<script>
import { Editor } from '@wangeditor/editor-for-vue'
import { Servicer } from '@/api/module/customerServiceCenter'
import store from '@/store'
import get from 'lodash/get'
export default {
  components: { Editor },
  data() {
    return {
      editor: null,
      html: '',
      toolbarConfig: {},
      editorConfig: {
        readOnly: true,
        scroll: false // 可将 scroll 设置为 false 的情况：编辑器高度自增
      },
      mode: 'default', // or 'simple',
      problem: '',
      empty: null
    }
  },

  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    async getQaDetail(id) {
      try {
        if (id) {
          const { code, data } = await Servicer.getQaDetail({ id })
          if (code === 1) {
            if (data) {
              const problem = data.problem || ''
              const richText = data.solution || ''
              this.empty = false
              this.problem = problem
              const isImsg = richText.indexOf('img') > -1 && richText.indexOf('img') > -1
              if (isImsg) {
                const imgSrcList = this.getDomImgSrc(richText)
                if (Array.isArray(imgSrcList) && imgSrcList.length) {
                  const { code: picCode, data: picData } = await Servicer.getPicSrcList(imgSrcList)
                  if (picCode === 1) {
                    const newRichText = this.replaceSrcInRichText(richText, picData)
                    this.html = newRichText
                  }
                }
              } else {
                this.html = richText
              }
            } else {
              this.empty = true
            }
          }
        }
      } catch (error) {
        console.log('🚀 ~ getQaDetail ~ error:', error)
      }
    },
    getDomImgSrc(richText) {
      if (richText) {
        const parser = new DOMParser()
        const doc = parser.parseFromString(richText, 'text/html')
        const imgTags = Array.from(doc.getElementsByTagName('img'))
        const srcValues = imgTags.map(tag => tag.getAttribute('src'))
        return srcValues
      }
      return []
    },
    replaceSrcInRichText(richText, srcMap) {
      // 使用DOMParser解析富文本
      const parser = new DOMParser()
      const doc = parser.parseFromString(richText, 'text/html')
      // 获取所有img标签
      const images = doc.querySelectorAll('img')

      // 替换SRC属性
      images.forEach(img => {
        const originalSrc = img.getAttribute('src')
        const newSrc = get(srcMap, originalSrc)
        if (originalSrc && newSrc) {
          img.setAttribute('src', newSrc)
        }
      })
      // 返回处理后的HTML
      return doc.body.innerHTML
    }
  },
  mounted() {
    // 模拟 ajax 请求，异步渲染编辑器
    const { query } = this.$route
    const id = query.id || ''
    const tokenQ = query.token
    const token = decodeURIComponent(tokenQ)
    store.dispatch('SET_TOKEN', token).then(() => {
      if (id) {
        console.log('问题id :>> ', id)
        this.getQaDetail(id)
      }
    })
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  }
}
</script>

<style lang="scss" scoped>
.pages {
  width: 100vw;
  height: 100vh;
  padding: 10px 20px;
  box-sizing: border-box;
  background-position: left top;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-image: url('https://cms.jtexpress.com/operatingplatform/miniPrograms/cs-bg.png');
  overflow: hidden;
  overflow-y: auto;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
.editor {
  flex: 1;
  height: auto;
  overflow: hidden;
  flex-shrink: 0;
}
.card-container {
  box-sizing: border-box;
  width: 100%;
  height: auto;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.0427);
}
.card-header {
  box-sizing: border-box;
  min-height: 45px;
  border-radius: 10px 10px 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px;
  flex-shrink: 0;
  border-bottom: 1px solid #f7f7f7;
}
.card-body {
  box-sizing: border-box;
  height: auto;
  width: 100%;
  border-radius: 0 0 10px 10px;
  padding: 15px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.card-header_title {
  display: inline-block;
  margin-right: 10px;
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0px;
  box-sizing: border-box;

  color: #171921;

  flex: auto;
}
.q-icon {
  box-sizing: border-box;
  width: 19px;
  height: 19px;
  border-radius: 4px;
  background: linear-gradient(180deg, #74a5ff 0%, #2283f3 99%);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  font-weight: normal;
  text-align: center;
  letter-spacing: 0px;
  color: #ffffff;
  margin-right: 6px;
  flex-shrink: 0;
}
.a-icon {
  box-sizing: border-box;
  width: 19px;
  height: 19px;
  border-radius: 4px;
  background: linear-gradient(180deg, #fe7f7f 0%, #fd4b43 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  font-weight: normal;
  text-align: center;
  letter-spacing: 0px;
  color: #ffffff;
  margin-right: 6px;
  flex-shrink: 0;
}

.tips-box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-sizing: border-box;

  img {
    width: 200px;
  }

  &-text {
    width: 150px;
    text-align: center;
    color: #a7a7a7;
    font-size: 16px;
    margin-top: 20px;
  }
}
</style>
